/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmailScheduleExcludingPayloadWithRelations } from './emailScheduleExcludingPayloadWithRelations';


/**
 * (tsType: Omit<EmailScheduleRunWithRelations, \'payload\'>, schemaOptions: { includeRelations: true, exclude: [ \'payload\' ] })
 */
export interface EmailScheduleRunExcludingPayloadWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    scheduleId: string;
    runAt: string;
    status?: EmailScheduleRunExcludingPayloadWithRelations.StatusEnum;
    emailId?: number | null;
    errorMessage?: string | null;
    processedOn?: string | null;
    schedule?: EmailScheduleExcludingPayloadWithRelations;
}
export namespace EmailScheduleRunExcludingPayloadWithRelations {
    export type StatusEnum = 'pending' | 'processing' | 'sent' | 'failed' | 'cancelled';
    export const StatusEnum = {
        Pending: 'pending' as StatusEnum,
        Processing: 'processing' as StatusEnum,
        Sent: 'sent' as StatusEnum,
        Failed: 'failed' as StatusEnum,
        Cancelled: 'cancelled' as StatusEnum
    };
}


